import React, {
    useEffect,
    useState
} from "react";

import axios from "axios";

import "./VaultHero.css";

import {
    Star,
    Shield,
    Award
} from "lucide-react";


const VaultHero = () => {

    const email =
        localStorage.getItem(
            "user_email"
        );


    /* ==============================
       PROFILE DATA
    ============================== */

    const [data, setData] =
        useState(null);


    /* ==============================
       COURSE DATA
    ============================== */

    const [courseStatus, setCourseStatus] =
        useState(null);


    /* ==============================
       LOAD DATA
    ============================== */

    useEffect(() => {

        if (email) {

            loadData();

        }

    }, [email]);


    const loadData = async () => {

        try {

            const [

                profileRes,

                courseRes

            ] = await Promise.all([

                /* =========================
                   EXISTING PROFILE API
                ========================= */

                axios.get(

                    `/api/ignite/profile/${email}`

                ),

                /* =========================
                   NEW COURSE STATUS API
                ========================= */

                axios.get(

                    `/api/ignite/course/status/${email}`

                )

            ]);


            /* =========================
               PROFILE
            ========================= */

            setData(

                profileRes.data

            );


            /* =========================
               COURSE STATUS
            ========================= */

            if (
                courseRes.data.success
            ) {

                setCourseStatus({

                    neuroPerformanceFoundational:
                        courseRes.data.courses
                            ?.neuroPerformanceFoundational || false,

                    eyeHealthAthleticEdition:
                        courseRes.data.courses
                            ?.eyeHealthAthleticEdition || false,

                    eyeHealthDetailed:
                        courseRes.data.courses
                            ?.eyeHealthDetailed || false,

                    allCoursesCompleted:
                        courseRes.data.allCoursesCompleted || false

                });

            }

        }

        catch (err) {

            console.error(

                "Vault Hero Error:",

                err

            );

        }

    };


    /* ==============================
       LOADING
    ============================== */

    if (
        !data ||
        !courseStatus
    ) {

        return (

            <div className="vault-hero">

                Loading...

            </div>

        );

    }


    /* ==============================
       PROFILE SUMMARY
    ============================== */

    const {
        summary
    } = data;


    /* ==============================
       CURRENT LEVEL
    ============================== */

    const currentLevel =
        summary?.currentLevel || 1;


    const levelNames = {

        1: "ROOKIE",

        2: "CONTENDER",

        3: "PERFORMER",

        4: "ELITE"

    };


    /* ==============================
       COURSE PROGRESS
    ============================== */

    const completedCourses = [

        courseStatus
            .neuroPerformanceFoundational,

        courseStatus
            .eyeHealthAthleticEdition,

        courseStatus
            .eyeHealthDetailed

    ].filter(Boolean).length;


    const totalCourses = 3;


    const courseProgress =

        Math.round(

            (

                completedCourses /

                totalCourses

            ) * 100

        );


    return (

        <div className="vault-hero">


            {/* =======================
               VAULT IMAGE
            ======================= */}

            <div className="vault-chest">

                <img

                    src="/attch/vault.png"

                    alt="Vault"

                />

            </div>


            {/* =======================
               TOTAL XP
            ======================= */}

            <div className="vault-stat">

                <Star/>

                <div>

                    <h2>

                        {summary?.totalXP || 0}

                    </h2>

                    <p>

                        Total XP

                    </p>

                </div>

            </div>


            <div className="vault-divider"/>


            {/* =======================
               CURRENT LEVEL
            ======================= */}

            <div className="vault-stat">

                <Shield/>

                <div>

                    <h2>

                        Level {currentLevel}

                    </h2>

                    <p>

                        {
                            levelNames[
                                currentLevel
                            ]
                        }

                    </p>

                </div>

            </div>


            <div className="vault-divider"/>


            {/* =======================
               BADGES
            ======================= */}

            <div className="vault-stat">

                <Award/>

                <div>

                    <h2>

                        {summary?.unlocked || 0}

                    </h2>

                    <p>

                        Badges Unlocked

                    </p>

                </div>

            </div>


            <div className="vault-divider"/>


            {/* =======================
               COURSE COMPLETION
            ======================= */}

            <div className="vault-completion">

                <svg
                    viewBox="0 0 120 120"
                >

                    <circle

                        cx="60"

                        cy="60"

                        r="48"

                    />


                    <circle

                        className="progress"

                        cx="60"

                        cy="60"

                        r="48"

                        style={{

                            strokeDashoffset:

                                302 -

                                (

                                    courseProgress /

                                    100

                                ) *

                                302

                        }}

                    />

                </svg>


                <div>

                    <h2>

                        {courseProgress}%

                    </h2>

                    <p>

                        Course Progress

                    </p>

                </div>

            </div>


        </div>

    );

};


export default VaultHero;